import { Card, Stack, Typography, useTheme } from "@mui/material";
import NoResults from "../assets/images/noresults.png";

const NoDataFound = ({ message = "No Data Found" }) => {
  const theme = useTheme();

  return (
    <Card
      variant="outlined"
      sx={{ borderRadius: 2, bgcolor: theme.palette.grey[50] }}
    >
      <Stack justifyContent="center" alignItems="center" spacing={2} my={3}>
        <img src={NoResults} alt="No Result" width="120px" />
        <Typography variant="h5" fontWeight={400}>
          {message}
        </Typography>
      </Stack>
    </Card>
  );
};

export default NoDataFound;
